import React from 'react'

import Icon, { Props } from './Icon'

const IconClock: React.FC<Props> = (props) => {
  return (
    <Icon title="" viewBox="0 0 24.659 24.659" {...props}>
      <path d="M12.329 0a12.329 12.329 0 1012.33 12.329A12.329 12.329 0 0012.329 0zm5.527 17.857a1.174 1.174 0 01-1.66 0L11.5 13.16a1.174 1.174 0 01-.344-.83V5.284a1.174 1.174 0 012.348 0v6.559l4.353 4.357a1.174 1.174 0 010 1.657z" />
    </Icon>
  )
}

export default IconClock
